import { NumberListItem } from '../../store/refund/types';

export function createLabel(fromYear: NumberListItem, toYear: NumberListItem): string {
    if (!fromYear) {
        if (!toYear) {
            return '';
        }
        return toYear.label;
    }
    if (!toYear) {
        return fromYear.label;
    }
    if (fromYear.value === toYear.value) {
        return fromYear.label;
    } else {
        return `${fromYear.label} - ${toYear.label}`;
    }
}
